// extracted by mini-css-extract-plugin
module.exports = {"disableScroll":"MegaMenuMobile_disableScroll__2342X","iconItems":"MegaMenuMobile_iconItems__3E5XR","contentMenu":"MegaMenuMobile_contentMenu__1w8cZ"};